import { call } from '@rental/contracts/client'
import { api, load } from './api'

/**
 * One booking's answer, read by its page and its return, and by the
 * hand-over for what the person may do on it (S9): one query, one cache entry.
 */
export function bookingQuery(code: string) {
  return {
    queryKey: ['booking', code.toUpperCase()],
    queryFn: () => load(call(api.GET('/v1/staff/bookings/{code}', { params: { path: { code } } }))),
  }
}
